<ag-grid-angular
  class="ag-theme-alpine"
  [pagination]="true"
  [serverSideInfiniteScroll]="true"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [statusBar]="statusBar"
  [getContextMenuItems]="getContextMenuItems"
  [sideBar]="sideBar"
  [rowSelection]="rowSelection"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [pivotPanelShow]="pivotPanelShow"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [enableRangeSelection]="false"
  [suppressCopyRowsToClipboard]="true"
  [rowModelType]="rowModelType"
  [columnDefs]="columnDefs"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [pinnedTopRowData]="pinnedTopRowData"
  [defaultColDef]="defaultColDef"
  [rowData]="rowData$ | async"
  (cellEditingStarted)="cellEditingStarted($event)"
  [animateRows]="true"
  [suppressRowClickSelection]="false"
  [rowClassRules]="rowClassRules"
  [enableCellChangeFlash]="enableCellChangeFlash"
  [stopEditingWhenCellsLoseFocus]="false"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (filterChanged)="filterChanged($event)"
></ag-grid-angular>
<!--[stopEditingWhenGridLosesFocus]="false"-->

